import { msalInstance, apiTokenRequest, isMsalConfigured } from "../auth/msalConfig";

/**
 * Acquire an access token for the backend API.
 *
 * Returns null when MSAL is not configured (local dev without Entra),
 * when no user is signed in, or when token acquisition fails — callers
 * should treat null as "skip the Authorization header" so unauthenticated
 * flows still function.
 *
 * Tries silent first; falls back to a popup only if silent fails (e.g.
 * refresh token expired, consent required).
 */
export async function getAccessToken() {
  if (!isMsalConfigured || !msalInstance) return null;
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;

  const request = { ...apiTokenRequest, account: accounts[0] };

  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (silentError) {
    try {
      const response = await msalInstance.acquireTokenPopup(request);
      return response.accessToken;
    } catch (popupError) {
      console.error("MSAL token acquisition failed:", popupError);
      return null;
    }
  }
}
